import tonegan from "../assets/icons/tonegan.png";

export const EXPERIENCE = [
    {
        title: "Software Developer",
        company_name: "Tonegan Ltd (Dobrich, Bulgaria)",
        icon: tonegan,
        date: "December 2015 - Present",
        descriptions: [
            "Developing and maintaining Enterprise Resource Planning (ERP) solutions using Delphi, Android and MS SQL Server.",
            "Implementation and configuration of ERP modules according to customer needs, with flexibility for expansion.",
            "Participation in custom software development, including specific modules for customer production and sales activities.",
            "Integration of mobile solutions for working on the go and managing sales and deliveries on site at the customer."
        ]
    }      
]